<template>
  <div v-loading='loading'>
    <div class="writeBox" style="margin-top: -30px;border-top: none;">
      <div class="writeItem" v-for="(item,index) in mediumData" :key="index">
        <label>{{item.name}}</label>
        <el-checkbox v-if="item.type == 'flag'" v-model="mediumData[index].value">是</el-checkbox>
        <el-input class="input" v-else-if="item.type=='value'" v-model="mediumData[index].value" @input="(val)=>{clearNoNum({value:val,valueName:index})}" :placeholder="item.name" size='mini' :disabled="item.disabled || false"></el-input>
        <el-select class="input" v-else-if="item.type=='list'" v-model="mediumData[index].value" size='mini' filterable placeholder="请选择" :disabled="item.disabled || false">
          <el-option v-for="(its,ins) in item.list" :key="ins" :label="its.name" :value="its.name">
          </el-option>
        </el-select>
        <el-date-picker v-else-if="item.type=='date'" class="input" v-model="mediumData[index].value" type="date" size="mini" value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="选择日期">
        </el-date-picker>
        <el-input class="input" v-else v-model="mediumData[index].value" :placeholder="item.name" size='mini'></el-input>
      </div>
    </div>

    <div class="writeBox calculation">
      <div class="writeItem" v-for="(item,index) in computedData" :key="index">
        <label>{{item.name}}：</label>
        <span :style="(index=='profit'&&profit<0) || (index=='gross_margin'&&parseFloat(gross_margin)<0)?'color:red':''">{{index=='ratio_of_consumption_to_top_rebate'?ratio_of_consumption_to_top_rebate:
                    index=='actual_cost_sum'?actual_cost_sum:
                    index=='rebate'?rebate:
                    index=='ratio_of_consumption_to_top_income'?ratio_of_consumption_to_top_income:
                    index=='flow_boost_rebate_income'?flow_boost_rebate_income:
                    index=='actual_cost'?actual_cost:
                    index=='profit'?profit:
                    index=='gross_margin'?gross_margin:
                    index=='rebate_amount_receivable'?rebate_amount_receivable:
                    ''
                }}</span>
      </div>
    </div>
    <div class="writeBox calculation">
      <div class="writeItem" v-for="(item,index) in totalColumnsJson" :key="index">
        <template v-if="!mediumData[item.prop]&&!computedData[item.prop]">
          <label>{{item.label}}：</label>
          <span>{{editData[item.prop]}}</span>
        </template>
      </div>
    </div>
    <!-- 提交修改原因 -->
    <div class="writeBox" v-if="editData.status>2">
      <p class="title">修改原因</p>
      <div class="writeItem" style="width:90%">
        <el-input class="input" type="textarea" v-model.trim="op_reason" placeholder="请输入修改原因" size='mini'></el-input>
      </div>
    </div>
    <!-- button  -->
    <div class="buttones">
      <button class="yes" @click="orderUpdate()">{{editData.status>2?'提交':'确定'}}</button>
      <button @click="orderCancelClick">取消</button>
    </div>
  </div>
</template>
<script>
import columnsJson from '../json/total.js'
export default {
  props: ['editDataTotal'],
  data () {
    // S 获取当前角色是否具备可编辑权限
    const isEditableRoleIds = [12]
    const currentRoleId = JSON.parse(this.$cookie.getCookie('userInfo') || '{}').role_id || 0
    const isEditable = isEditableRoleIds.includes(Number(currentRoleId))
    // E 获取当前角色是否具备可编辑权限

    return {
      editData: JSON.parse(JSON.stringify(this.editDataTotal)),
      op_reason: '',
      loading: false,
      pickerOptions: {
        // disabledDate(time) {
        //     return time.getTime() > Date.now();
        // },
      },
      totalColumnsJson: columnsJson,
      mediaList: [],
      mediumData: {
        if_public: {
          value: false,
          type: 'flag',
          name: '是否对公'
        },
        cost: {
          value: '',
          type: 'value',
          name: '订单成本消耗',
          disabled: isEditable ? false : true,
        },
        traffic_boost_refund: {
          value: '',
          type: 'value',
          name: '流量助推(使用返货)',
          disabled: isEditable ? false : true,
        },
        traffic_boost_money: {
          value: '',
          type: 'value',
          name: '流量助推(使用现金)',
          disabled: isEditable ? false : true,
        },
        cost_invoice_date: {
          value: '',
          type: 'date',
          name: '成本开票日期'
        },
        confirmed_cost_includes_tax: {
          value: '',
          type: 'value',
          name: '确认成本(含税)发票金额'
        },
        offline_subsidy_company: {
          value: '',
          type: 'list',
          list: [],
          name: '线下付款公司',
          disabled: isEditable ? false : true,
        },
        offline_subsidy_amount: {
          value: '',
          type: 'value',
          name: '线下付款金额',
          disabled: isEditable ? false : true,
        },
        // offline_invoice_date: {
        //   value: '',
        //   type: 'date',
        //   name: '线下补款开票日期'
        // },
        // offline_confirmed_cost_includes_tax: {
        //   value: '',
        //   type: 'value',
        //   name: '线下确认成本(含税)发票金额'
        // },
        red_invoice_date: {
          value: '',
          type: 'date',
          name: '红字发票信息表日期'
        },
        refund_invoice_date: {
          value: '',
          type: 'date',
          name: '返点开票日期'
        },
        note: {
          value: '',
          name: '备注'
        },
        offline_celeb_name: {
          value: '',
          name: '收款人姓名'
        },
        offline_pay_date: {
          value: '',
          type: 'date',
          name: '付款日期'
        },
        mcn_name: {
          value: '',
          type: 'list',
          list: [],
          name: 'mcn机构'
        },
        // mcn_rebate:{
        //     value:'',
        //     type:'value',
        //     name:'mcn返点收入',
        // },
        organization_amount: {
          value: '',
          type: 'value',
          name: '机构到手金额'
        },
        mcn_final_amount: {
          value: '',
          type: 'value',
          name: 'mcn最终收入金额'
        },
        mcn_user: {
          value: '',
          type: 'list',
          list: [],
          name: 'mcn负责人'
        },
        offline_cost_invoice_amount: {
          value: '',
          type: 'value',
          name: '线下成本发票金额'
        },
        offline_cost_invoice_date: {
          value: '',
          type: 'date',
          name: '线下成本发票日期'
        },
        media_name: {
          value: '',
          type: 'list',
          list: [],
          name: '媒体名称',
          disabled: isEditable ? false : true,
        },
      },
      userInfo: {},
      companyList: [],
      taxRate: '',
      computedData: {
        ratio_of_consumption_to_top_rebate: { name: '预估总消耗与置顶返点比例' },
        actual_cost_sum: { name: '后台实付成本金额' },
        rebate: { name: '补款总额(含税)' },
        ratio_of_consumption_to_top_income: { name: '预估总消耗与置顶返点收入' },
        flow_boost_rebate_income: { name: '预估总流量助推返点收入' },
        actual_cost: { name: '当月实际消耗成本金额' },
        profit: { name: '当月毛利' },
        gross_margin: { name: '毛利率' },
        rebate_amount_receivable: { name: '应收返点金额(含税)' },
      },
    }
  },
  computed: {
    ratio_of_consumption_to_top_rebate: function () {//消耗与置顶返点比例
      var valueNumber = 0;//对公的消耗与置顶返点比例为0
      if (!this.mediumData.if_public.value) {
        this.mediaList.forEach((item) => {
          if (item.media_name == this.editData.media_name) {
            valueNumber = item.ratio_of_consumption_to_top_rebate
          }
        })
      }
      return valueNumber
    },
    actual_cost_sum: function () {//后台实付成本合计金额 = 订单成本金额消耗+置顶费
      return parseFloat((Number(this.mediumData.cost.value == '-' ? 0 : this.mediumData.cost.value) + Number(this.editData.top_fee)).toFixed(10))
    },
    rebate: function () {//补款总额(含税) = 线下补款金额 * 比例
      var srRate = this.editData.sr_rate
      this.companyList.forEach((item) => {
        if (item.company_name == this.mediumData.offline_subsidy_company.value) {
          srRate = item.rebate
        }
      })
      return parseFloat((Number(this.mediumData.offline_subsidy_amount.value == '-' ? 0 : this.mediumData.offline_subsidy_amount.value) * Number(srRate)).toFixed(10))
    },
    ratio_of_consumption_to_top_income: function () {//消耗与置顶返点收入 = 后台实付成本合计金额 * 消耗与置顶返点比例
      return parseFloat((Number(this.actual_cost_sum) * Number(this.ratio_of_consumption_to_top_rebate)).toFixed(10)).toFixed(2)
    },
    flow_boost_rebate_income: function () {//流量助推返点收入 = 流量助推(使用现金) * 流量助推返点比例
      var flow_boost_rebate_ratio = this.editData.flow_boost_rebate_ratio.split('%')
      flow_boost_rebate_ratio = Number(flow_boost_rebate_ratio[0]) / 100
      return parseFloat((Number(this.mediumData.traffic_boost_money.value == '-' ? 0 : this.mediumData.traffic_boost_money.value) * Number(flow_boost_rebate_ratio)).toFixed(10)).toFixed(2)
    },
    actual_cost: function () {//(当月实际消耗成本金额 = 订单成本金额消耗 + 流量助推合计 + 置顶费 - 消耗与置顶返点收入 - 流量助推返点收入 + 补款总额(含税)/this.taxRate)
      return parseFloat(((Number(this.mediumData.cost.value == '-' ? 0 : this.mediumData.cost.value) + Number(this.editData.traffic_boost_sum) + Number(this.editData.top_fee) - Number(this.ratio_of_consumption_to_top_income) - Number(this.flow_boost_rebate_income) + Number(this.rebate)) / this.taxRate).toFixed(10)).toFixed(2)
    },

    profit: function () {//当月毛利 = (订单最终收入金额 - 返点支出金额 + mcn最终收入金额)/1.06 - 当月实际消耗成本金额
      return parseFloat(((Number(this.editData.final_amount) - Number(this.editData.rebate_spending_amount) + Number(this.mediumData.mcn_final_amount.value)) / 1.06 - this.actual_cost).toFixed(10)).toFixed(2)
    },

    gross_margin: function () {//毛利率 = (订单最终收入金额 - 返点支出金额 + mcn最终收入金额)!=0? 毛利率/((订单最终收入金额 - 返点支出金额 + mcn最终收入金额)/1.06)
      return (Number(this.editData.final_amount) - Number(this.editData.rebate_spending_amount) + Number(this.mediumData.mcn_final_amount.value == '-' ? 0 : this.mediumData.mcn_final_amount.value)) != 0 ? (parseFloat((((Number(this.profit)) / ((Number(this.editData.final_amount) - Number(this.editData.rebate_spending_amount) + Number(this.mediumData.mcn_final_amount.value == '-' ? 0 : this.mediumData.mcn_final_amount.value)) / 1.06)).toFixed(10)) * 100).toFixed(2) + '%') : ''
    },
    rebate_amount_receivable: function () {//应收返点金额 = 消耗与置顶返点收入 + 流量助推返点收入
      return parseFloat((Number(this.ratio_of_consumption_to_top_income) + Number(this.flow_boost_rebate_income)).toFixed(10))
    },
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    this.companyListEvent();
    this.getMediumList()
    this.mediaListEvent()
    this.mcnListEvent();
    this.taxRateEvent()
    for (var i in this.mediumData) {
      this.mediumData[i].value = this.editData[i]
    }
  },
  methods: {
    clearNoNum ({ value, valueName, mainName }) {//判断只能输入纯数字或者小数点，及负整数
      var t = value.charAt(0);
      //先把非数字的都替换掉，除了数字和.
      value = value.replace(/[^\d.]/g, "");
      //必须保证第一个为数字而不是.
      value = value.replace(/^\./g, "");
      //保证只有出现一个.而没有多个.
      value = value.replace(/\.{2,}/g, ".");
      //保证.只出现一次，而不能出现两次以上
      value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      //如果第一位是负号，则允许添加   如果不允许添加负号 可以把这块注释掉
      if (t == '-') {
        value = '-' + value;
      }
      this.mediumData[valueName].value = value
    },
    orderCancelClick () {
      this.$emit('cancelToast')
    },
    orderUpdate () {//编辑订单
      if (this.editData.status > 2 && this.op_reason == '') {
        this.$message({
          message: '请输入修改原因！',
          type: 'warning'
        })
        return
      }
      var params = {
        id: this.editData.id,
      }
      for (var i in this.mediumData) {
        if (i == 'if_public') {
          params[i] = this.mediumData[i].value ? 1 : 0
        } else {
          params[i] = this.mediumData[i].value
        }
      }
      if (this.editData.status > 2 && this.op_reason != '') {
        params.op_reason = this.op_reason
        params.verify_edit = 1
      }
      this.loading = true;
      this.$axios.post(this.URL.BASEURL + this.URL.newOrderUpdate, params).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.$message({
            message: '编辑成功！',
            type: 'success'
          })
          this.$emit('emit_refresh')
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    mediaListEvent () {//媒体列表
      var month = this.editData.month;
      this.$axios.get(this.URL.BASEURL + this.URL.mediaListSelect, {
        params: {
          month: month
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.mediaList = res.rst;
          this.mediumData.media_name.list = []
          this.mediaList.forEach((item) => {
            this.mediumData.media_name.list.push({ name: item.media_name })
          })
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    getMediumList () {
      this.$axios.get(this.URL.BASEURL + this.URL.users, {
        params: {
          page: 1,
          page_size: 999,
          role_id: [9, 13] // 9 媒介 13 媒介审核
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          var arr = res.rst.data;
          var data_arr = arr.filter((v) => {
            return v.real_name
          })
          this.mediumData.mcn_user.list = []
          data_arr.forEach((item) => {
            this.mediumData.mcn_user.list.push({ name: item.real_name })
          })
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    companyListEvent () {//线下付款公司
      this.$axios.get(this.URL.BASEURL + this.URL.companyList, {
        params: {
          page: 1,
          page_size: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          var arr = res.rst.data;
          this.companyList = arr;
          arr.forEach((item) => {
            item.name = item.company_name
          })
          this.mediumData.offline_subsidy_company.list = arr;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    taxRateEvent () {
      var month = this.editData.month;
      this.$axios.get(this.URL.BASEURL + this.URL.taxRate, {
        params: {
          month: month,
          page: 1,
          pagesize: 9999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.taxRate = 1.06
          res.rst.data.forEach((item) => {
            if (item.cost_company_name == this.editData.cost_company_name) {
              this.taxRate = item.rate
            }
          })
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    mcnListEvent (page) {
      this.$axios.get(this.URL.BASEURL + this.URL.mcnList, {
        params: {
          page: 1,
          page_size: 9999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.mediumData.mcn_name.list = res.rst.data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.basicsBox {
  margin-top: -20px;
  .basics {
    color: #5e5f6b;
    font-size: 12px;
    line-height: 20px;
    vertical-align: middle;
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 10px;
    label {
      vertical-align: middle;
      color: #202652;
    }
    span {
      vertical-align: middle;
    }
    .input {
      width: 100px;
    }
    .ellipsis {
      width: 120px;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.writeBox {
  border-top: 1px solid #e6e6ef;
  margin-top: 10px;
  padding-bottom: 10px;
  .title {
    color: #202652;
    font-size: 14px;
    line-height: 21px;
    font-weight: 500;
    margin-top: 16px;
  }
  .writeItem {
    display: inline-block;
    width: 49%;
    vertical-align: middle;
    margin-top: 10px;
    label {
      width: 160px;
      color: #202652;
      font-size: 12px;
      line-height: 20px;
      display: inline-block;
      vertical-align: middle;
    }
    .input {
      width: calc(100% - 200px);
      display: inline-block;
    }
  }
}
.calculation {
  padding-bottom: 0;
  .writeItem {
    width: 33.3%;
    margin-top: 10px;
    label {
      max-width: 230px;
      width: auto;
    }
    span {
      font-size: 12px;
    }
  }
}
.buttones {
  text-align: center;
  margin-top: 30px;
  button {
    width: 91px;
    height: 32px;
    border-radius: 4px;
    border: 1px solid #dcdfe5;
    color: #202652;
    font-size: 14px;
    background: transparent;
    margin: 0 4px;
  }
  .yes {
    border-color: #5b7bfe;
    background: #5b7bfe;
    color: #ffffff;
  }
}
.stars {
  color: red;
}
.hint {
  font-size: 12px;
  display: inline-block;
  line-height: 17px;
  vertical-align: middle;
  padding-left: 10px;
  color: #ea853c;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/medium/totalEdit.vue